import View from './view.js';

import icons from 'url:../../img/icons.svg'; //Parcel 2

class PaginationView extends View {
  _parentElement = document.querySelector('.pagination');

  addHandlerClick(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;

      const goToPage = +btn.dataset.goto; //converted to number
      //   console.log(goToPage);
      handler(goToPage);
    });
  }

  _generateMarkupButton(curPage, btn, numPages) {
    const prevB = `
      <button data-goto="${
        curPage - 1
      }" class="btn--inline pagination__btn--prev">
        <svg class="search__icon">
            <use href="${icons}#icon-arrow-left"></use>
        </svg>
        <span>Page ${curPage - 1}</span>
      </button>
         `;
    const nextB = `
    <button data-goto="${
      curPage + 1
    }" class="btn--inline pagination__btn--next">
      <span>Page ${curPage + 1}</span>
      <svg class="search__icon">
          <use href="${icons}#icon-arrow-right"></use>
      </svg>
    </button>
      `;
    const pageShower = `
    <div class="cur-page--shower__container">
      <span class="cur-page--shower">${curPage}/${numPages}</span>
    </div>
    `;
    if (btn === 'prev') return prevB + pageShower;
    if (btn === 'next') return pageShower + nextB;
    if (btn === 'both') return prevB + pageShower + nextB;
  }
  _generateMarkup() {
    const curPage = this._data.page;
    const numPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    );
    // console.log(numPages);
    // Page 1, and there are other pages
    if (curPage === 1 && numPages > 1) {
      return this._generateMarkupButton(curPage, 'next', numPages);
    }
    // Last page
    if (curPage === numPages && numPages > 1) {
      return this._generateMarkupButton(curPage, 'prev', numPages);
    }
    // Other page
    if (curPage < numPages) {
      return this._generateMarkupButton(curPage, 'both', numPages);
    }
    // Page 1, and there are NO pages
    return '';
  }
}

export default new PaginationView();
